import React from 'react';
import delhigovt from '../static/delhigovt.svg';
import Footer from './Footer';
import gplay from '../static/gplay.svg';
import appstore from '../static/appstore.svg';

const About = () =>
      <div>
        <main>
          <div className="maintitlebar"><h1>About</h1><img src={delhigovt} style={{ height: '70px' }} alt="delhi government logo" /></div>
            <div className="main--sections">
              <div id="about-us">
                <p>
                  Delhi Corona is the official platform of the Government of NCT of Delhi providing citizens with comprehensive resources to combat COVID using services of the line departments of GNCTD.
                  <br/>
                  <br/>
                </p>
                <p>
                  It has been made possible with the efforts and work of Health Department, IT Department and Revenue Department in GNCTD, DeGS, NIC and volunteer support from young programmers and UI/UX designers as well as technical assistance from multi-lateral organizations and technology companies. It aims to leverage technology to help fight against the spectre of Coronavirus. This platform will ensure a seamless experience for the user while complying with citizen friendly privacy and security norms.
                  <br/>
                  <br/>
                </p>
                <p>
                  It has been built as per the mandate enumerated in F. No. SS-1/HFW/COVID-19/2020/04/20-28. Global pandemics, by definition, cannot be restricted within the confines of state borders and boundaries. The medium of our response too, accordingly, needs to be equally ubiquitous. The tech revolution witnessed in the 21st century has brought a smartphone to almost every pocket around us.
                  <br/>
                  <br/>
                  Delhi Corona plans to make the most of this by providing a single avenue to cater to all the needs and issues - ranging from applying for ration to finding a shelter or a testing centre to tracking one’s symptoms - of the Delhi populace during these tough times. It will be built as a stack and continue to be updated over time. <br/>
                  <br/>
                    This Government of the people, by the people, and for the people cares for its citizens and resolves to stand together until this battle has been won. <br/>
                  <br/>
                  Hum Honge Kaamyaab!
                </p>
              </div>
            </div>
            <div>
              <h6 style={{borderBottom: 'none', paddingBottom: '5px'}}>Download the Official App</h6>
              <div>
                <a href="https://play.google.com/store/apps/details?id=com.delhi.covidcare">  <img src={gplay} style={{marginRight: '6px'}}/> </a>
                <a href="https://apps.apple.com/in/app/delhi-corona/id1516485091"> <img src={appstore}/>  </a>  
              </div>
            </div>
        </main>
        <Footer />
      </div>

export default About;
